import React, { useState } from 'react';
import './CoverDisplay.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useSwipeable } from 'react-swipeable';

const FALLBACK_IMAGE = {
  name: 'https://alientrader.net/cards/cards/images/cards/Temp.jpg',
  usrName: 'Image unavailable',
};

const CoverDisplay = ({ frontImage, backImage }) => {
  const [showBackImage, setShowBackImage] = useState(false);
  const safeFrontImage = frontImage?.name ? frontImage : FALLBACK_IMAGE;
  const safeBackImage = backImage?.name ? backImage : safeFrontImage;

  const toggleImage = () => setShowBackImage(prevState => !prevState);

  const handlers = useSwipeable({
    onSwipedLeft: toggleImage,
    onSwipedRight: toggleImage,
    onTap: toggleImage,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  return (
    <Container className='cover-display-container'>
      <Row>
        <Col className='imageBorderV2'>
          <div className='image-wrapper' {...handlers}>
            <div className={`flip-card-inner ${showBackImage ? 'flipped' : ''}`}>
              <div className='flip-card-front'>
                <img className='cover-image-display shadow' src={safeFrontImage.name} alt={safeFrontImage.usrName} />
              </div>
              <div className='flip-card-back'>
                <img className='cover-image-display shadow' src={safeBackImage.name} alt={safeBackImage.usrName} />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default CoverDisplay;
